(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vsedvir-apple2-context"]) return;
  try {
    
import('@shopify/events').then(({ StandardEvents }) => {

class VdCartContext extends HTMLElement {
  requestVersion = 0;

  connectedCallback() {
    document.addEventListener(StandardEvents.cartLinesUpdate, this.onCartUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener(StandardEvents.cartLinesUpdate, this.onCartUpdate);
    this.requestVersion += 1;
  }

  onCartUpdate = (event) => {
    if (!event.promise) return;
    const version = ++this.requestVersion;
    event.promise.then(({ cart, detail } = {}) => {
      if (!this.isConnected || version !== this.requestVersion) return;
      const quantity = cart?.totalQuantity ?? detail?.itemCount;
      if (!Number.isInteger(quantity) || quantity < 0) return;
      const empty = quantity === 0;
      const title = this.querySelector('.vda2-context__title');
      const text = this.querySelector('.vda2-context__text');
      const link = this.querySelector('.vda2-context__pill');
      if (title) title.textContent = empty ? this.dataset.emptyTitle : this.dataset.fullTitle;
      if (text) text.textContent = empty ? this.dataset.emptyText : this.dataset.fullText;
      if (link) link.hidden = !empty;
    }).catch(() => {});
  };
}

if (!customElements.get('vd-cart-context')) {
  customElements.define('vd-cart-context', VdCartContext);
}
});

  } catch(e) { console.error(e); }
})();
})();
